import EditAssociation from './EditAssociation.page';

export default EditAssociation;